import axios from 'axios';
import { LocalStore } from '../storage/authStore';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_BASE = `${API_URL}/api/admin/web-category`;

// Get auth token
const getAuthHeader = () => {
  const details = LocalStore.getCurrentUserDetails();
  const token = details ? details.token : null;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const webCategoryService = {
  // ==================== PARENT CATEGORIES (PostgreSQL API) ====================
  
  // Get parent categories for dropdowns (from PostgreSQL API)
  getParentCategoriesForDropdown: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/service-category/getCategories`, {
        ...getAuthHeader(),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching parent categories:', error);
      throw error;
    }
  },

  // ==================== CATEGORY MANAGEMENT (MongoDB) ====================
  
  // Get all categories from MongoDB (for table display)
  getAllCategories: async (params = {}) => {
    try {
      const response = await axios.get(API_BASE, {
        ...getAuthHeader(),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching web categories:', error);
      throw error;
    }
  },

  // Get category by ID
  getCategoryById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE}/${id}`, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error fetching web category:', error);
      throw error;
    }
  },

  // Create category
  createCategory: async (data) => {
    try {
      const response = await axios.post(API_BASE, data, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  // Update category
  updateCategory: async (id, data) => {
    try {
      const response = await axios.put(`${API_BASE}/${id}`, data, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },

  // Delete category
  deleteCategory: async (id) => {
    try {
      const response = await axios.delete(`${API_BASE}/${id}`, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  },

  // ==================== SUBCATEGORY MANAGEMENT ====================
  
  // Get all subcategories by category ID from MongoDB
  getSubCategoriesByCategoryId: async (categoryId, params = {}) => {
    try {
      const response = await axios.get(
        `${API_BASE}/${categoryId}/subcategories`,
        {
          ...getAuthHeader(),
          params
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching web subcategories:', error);
      throw error;
    }
  },

  // Get subcategory with subData
  getSubCategoryWithSubData: async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE}/subcategory/${id}`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategory with subData:', error);
      throw error;
    }
  },

  // ==================== SUBDATA (Location Content) Management ====================
  
  // Add location content (subData) to subcategory
  addSubDataToSubCategory: async (subCategoryId, subDataEntry) => {
    try {
      const response = await axios.post(
        `${API_BASE}/subcategory/${subCategoryId}/subdata`,
        subDataEntry,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error adding subData:', error);
      throw error;
    }
  },

  // Update location content in subcategory
  updateSubDataInSubCategory: async (subCategoryId, subdataIndex, subDataEntry) => {
    try {
      const response = await axios.put(
        `${API_BASE}/subcategory/${subCategoryId}/subdata/${subdataIndex}`,
        subDataEntry,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error updating subData:', error);
      throw error;
    }
  },

  // Delete location content from subcategory
  deleteSubDataFromSubCategory: async (subCategoryId, subdataIndex) => {
    try {
      const response = await axios.delete(
        `${API_BASE}/subcategory/${subCategoryId}/subdata/${subdataIndex}`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting subData:', error);
      throw error;
    }
  }
};
